export const MOBILE = 320;
export const TABLET = 768;
export const DESKTOP = 1200;
export const DESKTOP_LARGE = 1500;
export const DESKTOP_MAX = 1920;